/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
    ProductToJSONTyped,
} from './Product';

/**
 * 
 * @export
 * @interface OrderProduct
 */
export interface OrderProduct {
    /**
     * 
     * @type {string}
     * @memberof OrderProduct
     */
    id: string;
    /**
     * 
     * @type {Product}
     * @memberof OrderProduct
     */
    product: Product;
    /**
     * 
     * @type {number}
     * @memberof OrderProduct
     */
    quantity: number;
}

/**
 * Check if a given object implements the OrderProduct interface.
 */
export function instanceOfOrderProduct(value: object): value is OrderProduct {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function OrderProductFromJSON(json: any): OrderProduct {
    return OrderProductFromJSONTyped(json, false);
}

export function OrderProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'product': ProductFromJSON(json['product']),
        'quantity': json['quantity'],
    };
}

export function OrderProductToJSON(json: any): OrderProduct {
    return OrderProductToJSONTyped(json, false);
}

export function OrderProductToJSONTyped(value?: OrderProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'product': ProductToJSON(value['product']),
        'quantity': value['quantity'],
    };
}

